export class SeededRandom {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0;
  }

  next(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let value = this.state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4_294_967_296;
  }

  integer(min: number, max: number): number {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }

  pick<T>(values: readonly T[]): T {
    if (values.length === 0) {
      throw new Error("Cannot pick from an empty collection.");
    }
    return values[Math.floor(this.next() * values.length)];
  }

  weightedPick<T>(values: readonly T[], weight: (value: T) => number): T {
    const total = values.reduce((sum, value) => sum + Math.max(0, weight(value)), 0);
    if (total <= 0) {
      return this.pick(values);
    }
    let cursor = this.next() * total;
    for (const value of values) {
      cursor -= Math.max(0, weight(value));
      if (cursor <= 0) {
        return value;
      }
    }
    return values[values.length - 1];
  }
}

export function hashSeed(value: string): number {
  let hash = 2_166_136_261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16_777_619);
  }
  return hash >>> 0;
}
